  <div class="position-relative d-flex flex-row align-items-center h-100 px-2 px-sm-3" [ngClass]="{'search-active': showItem}">
    <a (click)="showItem = !showItem" class="d-flex flex-row align-content-center elsa-transition" title="Elsa Srl" appEmptyTitle>
      <img src="assets/icons/icon_search.svg" height="20" alt="Elsa Srl">
    </a>
    <div *ngIf="showItem" class="search-position">
      <input type="text" class="form-control-sm search-control" autofocus [formControl]="searchControl">
    </div>
  </div>
